import { render, staticRenderFns } from "./TheMediakit.vue?vue&type=template&id=5a428c3c&"
import script from "./TheMediakit.vue?vue&type=script&lang=js&"
export * from "./TheMediakit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports